























import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

@Component
export default class CommonInput extends Vue {
  @Prop()
  private value!: string;

  @Prop()
  private label?: string;

  @Prop()
  private name?: string;

  @Prop({default: []})
  private items!: object[];

  @Prop()
  private rules?: Array<any>;

  @Prop({default: ''})
  private errorMessage!: string;

  @Prop({default: false})
  private disabled!: boolean;

  @Prop({default: 'name'})
  private itemText!: string;

  @Prop({default: 'id'})
  private itemValue!: string;

  @Prop()
  private color?: string;

  @Prop({default: false})
  private dense?: boolean;

  @Prop({default: false})
  private dark?: boolean;

  @Prop({default: false})
  private fullWidth?: boolean;

  @Watch('value')
  watchPropValue() {
    this.inputData = this.value;
  }

  private inputData: string = '';

  private handleOnChange() {
    this.$emit('input', this.inputData);
    this.$emit('change', this.inputData);
  }
}
